<template>
  <sub-page :title="title">
    <div class="query-page">
      <!-- 类型A：开始年月 + 终止年月 + 信息脱敏(3项) -->
      <template v-if="queryType === 'range'">
        <div class="form-item">
          <div class="label">开始年月</div>
          <div class="input" @click="showPicker('start')">{{ startDate }}</div>
        </div>
        <div class="form-item">
          <div class="label">终止年月</div>
          <div class="input" @click="showPicker('end')">{{ endDate }}</div>
        </div>
      </template>

      <!-- 类型B/C：年度 -->
      <template v-else>
        <div class="form-item">
          <div class="label">年度</div>
          <div class="input" @click="showYearPicker">{{ year }}</div>
        </div>
      </template>

      <!-- 信息脱敏（类型A：3项 / 类型C：4项） -->
      <div class="form-item checkbox-group" v-if="queryType !== 'year'">
        <div class="label">信息脱敏</div>
        <div class="checkboxes">
          <div class="checkbox-item" :class="{ 'is-block': opt.block }" v-for="(opt, idx) in maskOptions" :key="idx">
            <input type="checkbox" :id="`mask-${idx}`" v-model="opt.checked" class="checkbox-native" />
            <label :for="`mask-${idx}`" class="checkbox-label">{{ opt.name }}</label>
          </div>
        </div>
      </div>

      <button class="preview-btn" @click="goPreview">预览</button>

      <!-- 预览加载中：白屏 + 蓝色太阳花 spinner -->
      <div class="loading-mask" v-if="loading">
        <div class="sun-spinner">
          <span
            v-for="i in 12"
            :key="i"
            class="spoke"
            :style="{ transform: `rotate(${(i - 1) * 30}deg)`, opacity: 1 - (i - 1) / 12 }"
          ></span>
        </div>
      </div>

      <!-- 年月选择器（底部滚轮） -->
      <div class="picker-mask" v-if="pickerVisible" @click="pickerVisible = false"></div>
      <div class="picker-panel" v-if="pickerVisible">
        <div class="picker-header">
          <div class="picker-cancel" @click="pickerVisible = false">取消</div>
          <div class="picker-confirm" @click="confirmPicker">确认</div>
        </div>
        <div class="picker-body">
          <!-- 年列 -->
          <div class="picker-column">
            <div
              class="picker-viewport"
              ref="yearViewport"
              @scroll.passive="onScroll('year')"
              @wheel.prevent="onWheel('year', $event)"
            >
              <div class="picker-pad"></div>
              <div
                v-for="(y, i) in years"
                :key="y"
                :class="['picker-item', itemClass(i, yearIndex)]"
                @click="scrollToIndex('year', i)"
              >{{ y }}</div>
              <div class="picker-pad"></div>
            </div>
            <div class="picker-line"></div>
            <div class="picker-line bottom"></div>
          </div>
          <!-- 月列 -->
          <div class="picker-column" v-if="pickerMode === 'yearmonth'">
            <div
              class="picker-viewport"
              ref="monthViewport"
              @scroll.passive="onScroll('month')"
              @wheel.prevent="onWheel('month', $event)"
            >
              <div class="picker-pad"></div>
              <div
                v-for="(m, i) in months"
                :key="m"
                :class="['picker-item', itemClass(i, monthIndex)]"
                @click="scrollToIndex('month', i)"
              >{{ String(m).padStart(2, '0') }}</div>
              <div class="picker-pad"></div>
            </div>
            <div class="picker-line"></div>
            <div class="picker-line bottom"></div>
          </div>
        </div>
      </div>
      <!-- 年度选择器（底部滚轮，仿参考图） -->
      <div class="yp-mask" v-if="yearPickerVisible" @click="yearPickerVisible = false"></div>
      <div class="yp-panel" v-if="yearPickerVisible">
        <div class="yp-header">
          <div class="yp-cancel" @click="yearPickerVisible = false">取消</div>
          <div class="yp-confirm" @click="confirmYear">确认</div>
        </div>
        <div class="yp-wheel">
          <div class="yp-viewport" ref="yearPickViewport"
            @scroll.passive="onYearScroll"
            @wheel.prevent="onYearWheel">
            <div
              v-for="(y, i) in yearList"
              :key="y"
              :class="['yp-item', yearItemClass(i)]"
              @click="scrollYearTo(i)"
            >{{ y }}</div>
            <div class="yp-pad"></div>
          </div>
          <div class="yp-line"></div>
          <div class="yp-line yp-line-2"></div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'RightsRecordQuery',
  components: { SubPage },
  data() {
    // 默认区间：终止年月=当前年月，开始年月=上一年同月（近一年）
    const now = new Date()
    const mm = String(now.getMonth() + 1).padStart(2, '0')
    const endYM = `${now.getFullYear()}${mm}`
    const startYM = `${now.getFullYear() - 1}${mm}`
    return {
      title: '个人权益记录查询打印',
      startDate: startYM,
      endDate: endYM,
      // 年度选择默认 2025
      year: '2025',
      maskOptions3: [
        { name: '单位名称', checked: false },
        { name: '缴费基数', checked: false },
        { name: '个人缴费金额', checked: false }
      ],
      maskOptions4: [
        { name: '单位名称', checked: false },
        { name: '缴费基数', checked: false },
        { name: '个人缴费金额', checked: false },
        { name: '单位缴费金额', checked: false, block: true }
      ],
      pickerVisible: false,
      yearPickerVisible: false,
      yearPickerValue: 2025,
      yearList: [],
      loading: false,
      pickerMode: 'yearmonth',
      pickerType: 'start',
      pickerYear: new Date().getFullYear(),
      pickerMonth: new Date().getMonth() + 1,
      years: [],
      months: [1,2,3,4,5,6,7,8,9,10,11,12]
    }
  },
  computed: {
    recordType() {
      return this.$route.query.type || ''
    },
    // range: 年月范围+脱敏3项; year: 仅年度; yearMask4: 年度+脱敏4项
    queryType() {
      if (this.recordType === '社会保险个人权益（城镇职工）') return 'yearMask4'
      if (this.recordType.indexOf('企业职工基本养老保险权益记录单') > -1) return 'range'
      // 江苏省社会保险权益记录单（参保人员）：表单与养老权益记录单一致
      if (this.recordType.indexOf('江苏省社会保险权益记录单') > -1) return 'range'
      // 机关事业单位养老保险个人账户权益记录单：仅年度，无信息脱敏
      return 'year'
    },
    maskOptions() {
      return this.queryType === 'yearMask4' ? this.maskOptions4 : this.maskOptions3
    },
    // 当前年/月在滚轮序列中的索引
    yearIndex() {
      let i = this.years.indexOf(this.pickerYear)
      // 超出动态范围时，定位到最近的一端（最早年或最晚年）
      if (i < 0) i = this.pickerYear < this.years[0] ? 0 : this.years.length - 1
      return i
    },
    monthIndex() {
      return Math.max(0, Math.min(11, this.pickerMonth - 1))
    }
  },
  created() {
    // 年月选择器：不设固定最小年，动态范围为当前年前30年~后10年，升序排列
    const nowYear = new Date().getFullYear()
    for (let i = nowYear - 30; i <= nowYear + 10; i++) {
      this.years.push(i)
    }
    // 年度选择器：2020年起，降序排列（选中年份在下，后续年份依次向下）
    for (let i = nowYear + 10; i >= 2020; i--) {
      this.yearList.push(i)
    }
  },
  beforeDestroy() {
    clearTimeout(this.loadingTimer)
    clearTimeout(this.snapTimer)
    clearTimeout(this.yearSnapTimer)
  },
  methods: {
    showPicker(type) {
      this.pickerMode = 'yearmonth'
      this.pickerType = type
      const current = type === 'start' ? this.startDate : this.endDate
      if (current && current.length >= 6) {
        this.pickerYear = parseInt(current.substring(0, 4))
        this.pickerMonth = parseInt(current.substring(4, 6))
      }
      this.pickerVisible = true
      this.positionViewports()
    },
    showYearPicker() {
      this.yearPickerValue = parseInt(this.year) || 2025
      this.yearPickerVisible = true
      this.$nextTick(() => {
        const vp = this.$refs.yearPickViewport
        if (vp) vp.scrollTop = this.yearIndexOf(this.yearPickerValue) * this.yearItemHeight(vp)
      })
    },
    // 年度在降序序列中的索引
    yearIndexOf(y) {
      let i = this.yearList.indexOf(y)
      if (i < 0) i = y > this.yearList[0] ? 0 : this.yearList.length - 1
      return i
    },
    yearItemHeight(vp) {
      const el = vp.querySelector('.yp-item')
      return el ? el.getBoundingClientRect().height : 0
    },
    // 点击某行：平滑滚动到顶部高亮带
    scrollYearTo(i) {
      const vp = this.$refs.yearPickViewport
      if (vp) vp.scrollTo({ top: i * this.yearItemHeight(vp), behavior: 'smooth' })
    },
    onYearScroll() {
      const vp = this.$refs.yearPickViewport
      if (!vp) return
      const h = this.yearItemHeight(vp)
      if (!h) return
      let idx = Math.round(vp.scrollTop / h)
      idx = Math.max(0, Math.min(this.yearList.length - 1, idx))
      if (this.yearPickerValue !== this.yearList[idx]) this.yearPickerValue = this.yearList[idx]
      clearTimeout(this.yearSnapTimer)
      this.yearSnapTimer = setTimeout(() => {
        vp.scrollTo({ top: idx * h, behavior: 'smooth' })
      }, 140)
    },
    onYearWheel(e) {
      const vp = this.$refs.yearPickViewport
      if (!vp) return
      const h = this.yearItemHeight(vp)
      let idx = Math.round(vp.scrollTop / h) + (e.deltaY > 0 ? 1 : -1)
      idx = Math.max(0, Math.min(this.yearList.length - 1, idx))
      vp.scrollTo({ top: idx * h, behavior: 'smooth' })
    },
    yearItemClass(i) {
      const d = Math.abs(i - this.yearIndexOf(this.yearPickerValue))
      if (d === 0) return 'active'
      if (d === 1) return 'near'
      if (d === 2) return 'far'
      return 'distant'
    },
    confirmYear() {
      this.year = String(this.yearPickerValue)
      this.yearPickerVisible = false
    },
    // 打开后无动画定位到当前选中项
    positionViewports() {
      this.$nextTick(() => {
        const yvp = this.$refs.yearViewport
        if (yvp) yvp.scrollTop = this.yearIndex * this.itemHeight(yvp)
        const mvp = this.$refs.monthViewport
        if (mvp) mvp.scrollTop = this.monthIndex * this.itemHeight(mvp)
      })
    },
    itemHeight(vp) {
      const el = vp.querySelector('.picker-item')
      return el ? el.getBoundingClientRect().height : 0
    },
    // 点击某行：平滑滚动居中
    scrollToIndex(which, i) {
      const vp = this.$refs[which + 'Viewport']
      if (vp) vp.scrollTo({ top: i * this.itemHeight(vp), behavior: 'smooth' })
    },
    // 滚动中：实时更新选中值，停止后吸附到最近一格
    onScroll(which) {
      const vp = this.$refs[which + 'Viewport']
      if (!vp) return
      const h = this.itemHeight(vp)
      if (!h) return
      const list = which === 'year' ? this.years : this.months
      let idx = Math.round(vp.scrollTop / h)
      idx = Math.max(0, Math.min(list.length - 1, idx))
      if (which === 'year') {
        if (this.pickerYear !== list[idx]) this.pickerYear = list[idx]
      } else if (this.pickerMonth !== list[idx]) {
        this.pickerMonth = list[idx]
      }
      clearTimeout(this.snapTimer)
      this.snapTimer = setTimeout(() => {
        vp.scrollTo({ top: idx * h, behavior: 'smooth' })
      }, 140)
    },
    // 鼠标滚轮：每格滚动
    onWheel(which, e) {
      const vp = this.$refs[which + 'Viewport']
      if (!vp) return
      const h = this.itemHeight(vp)
      const list = which === 'year' ? this.years : this.months
      let idx = Math.round(vp.scrollTop / h) + (e.deltaY > 0 ? 1 : -1)
      idx = Math.max(0, Math.min(list.length - 1, idx))
      vp.scrollTo({ top: idx * h, behavior: 'smooth' })
    },
    // 行样式档位：选中/邻近/较远/更远
    itemClass(i, sel) {
      const d = Math.abs(i - sel)
      if (d === 0) return 'active'
      if (d === 1) return 'near'
      if (d === 2) return 'far'
      return 'distant'
    },
    confirmPicker() {
      if (this.pickerMode === 'yearmonth') {
        const value = String(this.pickerYear) + String(this.pickerMonth).padStart(2, '0')
        if (this.pickerType === 'start') {
          this.startDate = value
        } else {
          this.endDate = value
        }
      } else {
        this.year = String(this.pickerYear)
      }
      this.pickerVisible = false
    },
    goPreview() {
      // 显示 loading，5 秒后再跳转
      this.loading = true
      this.loadingTimer = setTimeout(() => {
        this.loading = false
        this.doPreview()
      }, 5000)
    },
    doPreview() {
      const type = this.recordType
      // 勾选的脱敏项
      const mask = this.maskOptions.filter(o => o.checked).map(o => o.name)
      // 社会保险个人权益（城镇职工）→ 企业职工权益记录单
      if (type === '社会保险个人权益（城镇职工）') {
        this.$router.push({ path: '/social-insurance-detail', query: { year: this.year, mask: mask.join(',') } })
        return
      }
      // 江苏省企业职工基本养老保险权益记录单（参保人员）
      if (type.indexOf('企业职工基本养老保险权益记录单') > -1 && type.indexOf('参保人员') > -1) {
        this.$router.push({ path: '/jiangsu-pension-insured', query: { start: this.startDate, end: this.endDate, mask: mask.join(',') } })
        return
      }
      // 江苏省社会保险权益记录单（参保人员）
      if (type.indexOf('江苏省社会保险权益记录单') > -1) {
        this.$router.push({ path: '/jiangsu-social-insured', query: { start: this.startDate, end: this.endDate, mask: mask.join(',') } })
        return
      }
      // 其他类型跳转结果页（按类型显示对应提示）
      this.$router.push({
        path: '/rights-record-result',
        query: { type }
      })
    }
  }
}
</script>

<style scoped>
.query-page {
  background: #F3F8FB;
  min-height: 100%;
  /* 撑满 page-body，背景100%铺满 */
  flex: 1;
}
.form-item {
  background: #fff;
  padding: calc(36 * var(--w)) calc(32 * var(--w));
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: flex-start;
}
.label {
  font-size: calc(38 * var(--w));
  color: #323233;
  width: calc(220 * var(--w));
  flex-shrink: 0;
  line-height: calc(48 * var(--w));
}
.input {
  flex: 1;
  font-size: calc(38 * var(--w));
 cursor: pointer;
  line-height: calc(48 * var(--w));
  /* APK WebView：点击年度/开始年月/终止年月不出现灰色高亮阴影 */
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.checkbox-group {
  align-items: flex-start;
}
.checkboxes {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.checkbox-item {
  width: 50%;
  display: flex;
  align-items: center;
  margin-bottom: calc(16 * var(--w));
}
/* 单位缴费金额：独占一整行 */
.checkbox-item.is-block {
  width: 100%;
}
.checkbox-item:last-child {
  margin-bottom: 0;
}
/* 自定义复选框：APK WebView 原生 checkbox 渲染偏小，改为隐藏原生框、
   由 label::before 按设计稿绘制小尺寸细灰边直角方框（选中填充蓝色+白勾） */
.checkbox-native {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
}
.checkbox-label {
  position: relative;
  padding-left: calc(74 * var(--w));
  font-size: calc(48 * var(--w));
  color: #323233;
  line-height: calc(60 * var(--w));
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.checkbox-label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  /* 设计稿量取：52w 见方、直角、细灰边 */
  width: calc(52 * var(--w));
  height: calc(52 * var(--w));
  border: calc(2 * var(--w)) solid #A6ABB2;
  border-radius: calc(2 * var(--w));
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: calc(30 * var(--w)) calc(24 * var(--w));
}
/* 选中：蓝色填充 + 白色对勾 */
.checkbox-native:checked + .checkbox-label::before {
  border-color: #2E8CF6;
  background-color: #2E8CF6;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 16'%3E%3Cpath d='M2 8.5 L7.5 13.5 L18 2.5' fill='none' stroke='%23ffffff' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}
.preview-btn {
  display: block;
  width: calc(94%);
  height: calc(96 * var(--w));
  background: #1E7FFE;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  margin: calc(40 * var(--w)) auto 0;
  cursor: pointer;
}
/* 预览 loading：不透明白屏 + 蓝色太阳花 spinner */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fbfbfb;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sun-spinner {
  position: relative;
  width: calc(88 * var(--w));
  height: calc(88 * var(--w));
  animation: sun-spin 1s linear infinite;
}
.spoke {
  position: absolute;
  left: 50%;
  top: 0;
  width: calc(7 * var(--w));
  height: calc(24 * var(--w));
  margin-left: calc(-3.5 * var(--w));
  background: #54a1f1;
  border-radius: calc(4 * var(--w));
  transform-origin: center calc(44 * var(--w));
}
@keyframes sun-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
/* 年月/年度选择器（底部滚轮） */
.picker-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.55);
  z-index: 1000;
}
.picker-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 1001;
  overflow: hidden;
}
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(40 * var(--w)) calc(40 * var(--w));
}
.picker-cancel {
  font-size: calc(34 * var(--w));
  color: #969799;
  cursor: pointer;
}
.picker-confirm {
  font-size: calc(34 * var(--w));
  color: #1E7FFE;
  cursor: pointer;
}
.picker-body {
  position: relative;
  display: flex;
  padding: 0 0 calc(70 * var(--w));
}
.picker-column {
  position: relative;
  flex: 1;
}
/* 滚轮视口：显示 5 行，隐藏滚动条 */
.picker-viewport {
  position: relative;
  height: calc(550 * var(--w));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.picker-viewport::-webkit-scrollbar {
  display: none;
}
/* 首尾占位各 2 行高，使两端选项均可滚到居中位置 */
.picker-pad {
  height: calc(220 * var(--w));
}
.picker-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(110 * var(--w));
  font-size: calc(44 * var(--w));
  color: #d9d9d9;
  cursor: pointer;
  user-select: none;
}
.picker-item.far {
  color: #c0c2c6;
}
.picker-item.near {
  color: #969799;
}
/* 选中项：按设计稿仅为中等字重（非bold），字号加大保证APK内清晰 */
.picker-item.active {
  color: #1a1a1a;
  font-weight: 500;
  font-size: calc(52 * var(--w));
}
/* 选中区上下横线：跨列贯穿（左右不内缩），年/月两列的线连为一体 */
.picker-line {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% - 55 * var(--w));
  height: 1px;
  background: #e8e8e8;
  pointer-events: none;
}
.picker-line.bottom {
  top: calc(50% + 55 * var(--w));
}

/* ============ 年度选择器（仿参考图） ============ */
.yp-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.55);
  z-index: 1000;
}
.yp-panel {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  height: calc(918 * var(--w));
  background: #fff;
  z-index: 1001;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.yp-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(40 * var(--w));
}
.yp-cancel {
  font-size: calc(34 * var(--w));
  color: #969799;
  cursor: pointer;
}
.yp-confirm {
  font-size: calc(34 * var(--w));
  color: #5f6680;
  cursor: pointer;
}
.yp-wheel {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.yp-viewport {
  position: absolute;
  top: calc(327 * var(--w));
  left: 0; right: 0; bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.yp-viewport::-webkit-scrollbar { display: none; }
.yp-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(132 * var(--w));
  font-size: calc(44 * var(--w));
  color: #d9d9d9;
  cursor: pointer;
  user-select: none;
}
.yp-item.far { color: #c0c2c6; }
.yp-item.near { color: #969799; }
/* 选中项：按设计稿仅为中等字重（非bold），字号加大保证APK内清晰 */
.yp-item.active {
  color: #1a1a1a;
  font-weight: 500;
  font-size: calc(52 * var(--w));
}
/* 底部占位：使最后一个年份也能滚入顶部高亮带 */
.yp-pad { height: calc(331 * var(--w)); }
.yp-line {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(327 * var(--w));
  height: 1px;
  background: #ededed;
  pointer-events: none;
}
.yp-line-2 { top: calc(459 * var(--w)); }
</style>



// WEBPACK FOOTER //
// src/pages/RightsRecordQuery.vue